import React from "react";
import { ARTICLES } from "./Blog";
import { BLOG } from "./constants";

function StoriesTeaser({ onView }) {
  return (
    <section id="blog" className="section section--paper2">
      <div className="container">
        <div className="split">
          <div>
            <p className="eyebrow">From the Lodge</p>
            <h2>Stories &amp; reflections.</h2>
            <p className="lede">
              Pieces from the brethren — on the road to Freemasonry, the symbols we
              hold dear, and lives shaped by the Service.
            </p>
            <a
              className="btn"
              href="#blog"
              onClick={(e) => {
                e.preventDefault();
                onView(BLOG);
              }}
            >
              Read all stories <span className="arrow" aria-hidden="true">→</span>
            </a>
          </div>
          <div style={{ display: "grid", gap: 18 }}>
            {ARTICLES.map((a) => (
              <button
                key={a.id}
                onClick={() => onView(BLOG)}
                style={{
                  textAlign: "left",
                  background: "var(--paper-warm)",
                  border: "1px solid var(--ink-line)",
                  padding: "22px 24px",
                  cursor: "pointer",
                  transition: "all .25s var(--ease)",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = "var(--gold)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = "var(--ink-line)";
                }}
              >
                <p className="eyebrow" style={{ marginBottom: 6 }}>
                  Article
                </p>
                <h3 style={{ margin: "0 0 6px", fontSize: "1.4rem" }}>{a.title}</h3>
                <p style={{ margin: 0, color: "var(--muted)" }}>{a.subtitle}</p>
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default StoriesTeaser;
